module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), (_vm.isShowLogo) ? _c('div', [_c('h1', [_vm._v("Showing logo")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "400",
      "height": "300",
      "src": "{{",
      "city.cityLogo": "",
      "}}": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: " !loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n                            " + _vm._s(_vm.flashMessage) + "\n                        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "collection_location_scroll"
  }, [_c('div', {
    staticClass: "row collection_location_inner",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.cityName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city.cityName),
      expression: "city.cityName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "25",
      "name": "cityName",
      "required": "",
      "placeholder": "City Name",
      "pattern": "^[a-zA-Z]([a-zA-Z\\s!@#]{0,24}[a-zA-Z])*$"
    },
    domProps: {
      "value": (_vm.city.cityName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.city, "cityName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "cityName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("City Name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                                            Alphabets/Numbers are allowed.\n                                        ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.firstName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v(" Admin First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city.firstName),
      expression: "city.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "firstName",
      "required": "",
      "placeholder": "City Admin First Name",
      "pattern": "^[a-zA-Z]([a-zA-Z\\s!@#]{0,24}[a-zA-Z])*$"
    },
    domProps: {
      "value": (_vm.city.firstName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.city, "firstName", $event.target.value)
      }, function($event) {
        _vm.capitalizeFirstName()
      }]
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "firstName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                                            Admin First Name is a required field\n                                        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                                            Alphabets are allowed and upto 25 characters.\n                                        ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.lastName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v(" Admin Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city.lastName),
      expression: "city.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "lastName",
      "placeholder": "City Admin Last Name",
      "pattern": "^[a-zA-Z]([a-zA-Z\\s!@#]{0,24}[a-zA-Z])*$"
    },
    domProps: {
      "value": (_vm.city.lastName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.city, "lastName", $event.target.value)
      }, function($event) {
        _vm.capitalizeLastName()
      }]
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "lastName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                                            Alphabets are allowed and upto 25 characters.\n                                        ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": "",
      "custom": {
        email: _vm.emailValidator
      }
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city.email),
      expression: "city.email"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "email",
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.city.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.city, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "email",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "email"
    },
    slot: "email"
  }, [_vm._v("Email Id is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.document1),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("User ID Proof 1")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg,image/jpg,application/pdf",
      "id": "fileinput",
      "required": "",
      "name": "proof_1"
    },
    on: {
      "change": _vm.onDocumentchanged1
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "proof_1",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                                            Please upload less than 3mb picture\n                                        ")])]), _vm._v(" "), (
    _vm.$route.params &&
    _vm.$route.params._id != '0' &&
    _vm.city.licenceFront
  ) ? _c('div', {
    staticClass: "border p-2 mt-3"
  }, [_c('a', {
    attrs: {
      "href": _vm.city.licenceFront,
      "target": "_blank"
    }
  }, [_vm._v("\n                                            View\n                                        ")])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.document),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("User ID Proof 2")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg,image/jpg,application/pdf",
      "id": "fileinput1",
      "name": "proof_2"
    },
    on: {
      "change": _vm.onDocumentchanged2
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "proof_2",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                                            Please upload less than 3mb document\n                                        ")])]), _vm._v(" "), (
    _vm.$route.params &&
    _vm.$route.params._id != '0' &&
    _vm.city.licenceBack
  ) ? _c('div', {
    staticClass: "border p-2 mt-3"
  }, [_c('a', {
    attrs: {
      "href": _vm.city.licenceBack,
      "target": "_blank"
    }
  }, [_vm._v("\n                                            View\n                                        ")])]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.mobile),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Contact Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city.mobile),
      expression: "city.mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "string",
      "maxlength": "10",
      "name": "mobile",
      "placeholder": "Contact",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.city.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.city, "mobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "mobile",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Numbers are allowed.")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'city'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                                Cancel\n                            ")])]), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id == '0') ? _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createCity
    }
  }, [_vm._v("\n                            Save\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id != '0') ? _c('button', {
    staticClass: "btn gradientbt mr-5",
    attrs: {
      "type": "submit",
      "disabled": !((_vm.formstate.$dirty || _vm.isFileChange) && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.updateCity
    }
  }, [_vm._v("\n                            Update\n                        ")]) : _vm._e()], 1)], 1)])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e17aa232", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e17aa232"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/city/addCity.vue
// module id = 2390
// module chunks = 0